import { render, staticRenderFns } from "./ad-wxgame-playable.vue?vue&type=template&id=58272853&scoped=true"
import script from "./ad-wxgame-playable.vue?vue&type=script&setup=true&lang=js"
export * from "./ad-wxgame-playable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ad-wxgame-playable.vue?vue&type=style&index=0&id=58272853&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58272853",
  null
  
)

export default component.exports